const zIndices = {
  map: 400,
  topbar: 1001,
  sidebar: 1001,
};

export default zIndices;
